import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
`

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: ${themeGet('colors.text.important')};
  gap: ${themeGet('space.4')}px;

  svg {
    flex-shrink: 0;
    color: ${themeGet('colors.primary.main')};
  }

  &:hover {
    color: ${themeGet('colors.primary.dark')};

    svg {
      color: ${themeGet('colors.primary.dark')};
    }
  }
`
